import { ButtonHTMLAttributes, ReactNode } from 'react';

import { ButtonContainer } from './styles';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant: 'outlined' | 'contained' | 'text';
  rounded?: boolean;
  isRedButton?: boolean;
  children: ReactNode;
};

export function Button({
  variant,
  rounded = false,
  isRedButton = false,
  children,
  ...props
}: ButtonProps): JSX.Element {
  return (
    <ButtonContainer
      variant={variant}
      rounded={rounded}
      isRedButton={isRedButton}
      {...props}
    >
      {children}
    </ButtonContainer>
  );
}
